import React, { Fragment, useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import ClassCard from "../classes/ClassCard";
import ClassLevelsDropdown from "../dropdowns/ClassLevelsDropdown";
import { Checkbox } from "semantic-ui-react";
import InstructorsDropdown from "../dropdowns/InstructorsDropdown";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClock } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
registerLocale("pl", pl);

const UpdateClassData = (props) => {
    const { t } = useTranslation();
    const { onClose, c, reloadData } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [data, setData] = useState({
        class_name: c.class_name,
        class_level_code: c.class_level_code,
        instructor_user_id: c.instructor_id,
        instructor_label: c.instructor_label ? c.instructor_label : "",
        class_slots: c.class_slots,
        class_signup_start_time: c.class_signup_start_time,
    });

    const [multipleAction, setMultipleAction] = useState(false);
    const [startDate, setStartDate] = useState({
        date: new Date(c.class_start_time),
        startHour: new Date(c.class_start_time),
        endHour: new Date(c.class_end_time),
    });
    console.log(data);
    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];
        if (data.class_name === 0 || !data.class_name.replace(/\s+/, "")) {
            $("#className").addClass("is-invalid");
            errors.push(t("error.noClassName"));
        }
        if (!data.class_level_code) {
            $("#classLvl").addClass("is-invalid");
            errors.push(t("error.noSelectedClassLevel"));
        }

        if (!data.class_signup_start_time) {
            $("#classSignUpStartDate").addClass("is-invalid");
            errors.push(t("error.noClassSignUpStartDate"));
        } else if (!/^\d{4}-\d{2}-\d{2}$/.test(moment(data.class_signup_start_time).format("YYYY-MM-DD"))) {
            $("#classSignUpStartDate").addClass("is-invalid");
            errors.push(t("error.invalidClassSignUpStartDate"));
        } else $("#classSignUpStartDate").removeClass("is-invalid");

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.changingClassLevel") }]);
            setBlockForm(true);
            updateClassData();
        }
    };

    const updateClassData = async () => {
        console.log(c.class_start_time);
        const res = await postMethod("/update-class-data", {
            classID: c.class_id,
            classLvl: data.class_level_code,
            multipleAction: multipleAction,
            classStartDate: c.class_start_time,
            className: data.class_name,
            oldName: c.class_name,
            instructorID: data.instructor_user_id,
            instructor_label: data.instructor_label,
            class_slots: data.class_slots,
            startDate: startDate,
            classSignUpStartTime: data.class_signup_start_time,
            oldClassSignUpStartTime: c.class_signup_start_time,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "data.class_level_codeChanged" }]);
            reloadData();
        } else setBlockForm(false);
    };

    return (
        <Fragment>
            <Modal show={true} onHide={onClose} backdrop={formChanged ? "static" : true}>
                <Form onSubmit={checkValidation} autoComplete="off">
                    <Modal.Header closeButton>
                        <Modal.Title>{t("classes.editClassData")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={12} className="mb-3">
                                <ClassCard c={c} />
                            </Col>
                            <Col xs={12} className="mb-3">
                                <Form.Group controlId={"className"}>
                                    <Form.Label>
                                        {t("templates.className")} <span className="req">*</span>
                                    </Form.Label>
                                    <p className="text-small mb-2">{t("templates.classNameHelper")}</p>
                                    <Form.Control
                                        value={data.class_name}
                                        onChange={(e) => {
                                            setData({ ...data, class_name: e.target.value });
                                            $("#className").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                        placeholder={t("templates.typeClassName")}
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group>
                                    <Form.Label>
                                        {t("classes.classDate")} <span className="req">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={startDate.date}
                                        onChange={(date) => {
                                            setStartDate({ ...startDate, date: date });
                                            $("#classStartDate").removeClass("is-invalid");
                                            setFormChanged(true);
                                            //setUpdatedDate(true);
                                        }}
                                        showIcon
                                        locale="pl"
                                        dateFormat="yyyy-MM-dd"
                                        icon={<FontAwesomeIcon icon={faCalendar} />}
                                        className="mb-3"
                                        placeholderText={t("choose")}
                                        id="classStartDate"
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group>
                                    <Form.Label>
                                        {t("startHour")} <span className="req">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={startDate.startHour}
                                        onChange={(date) => {
                                            setStartDate({ ...startDate, startHour: date });
                                            $("#classStartDateStartHour").removeClass("is-invalid");
                                            setFormChanged(true);
                                            //setUpdatedDate(true);
                                        }}
                                        showIcon
                                        locale="pl"
                                        dateFormat="HH:mm"
                                        icon={<FontAwesomeIcon icon={faClock} />}
                                        className="mb-3"
                                        placeholderText={t("choose")}
                                        timeCaption={t("hour")}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={5}
                                        disabled={!startDate.date || blockForm}
                                        id={"classStartDateStartHour"}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group>
                                    <Form.Label>
                                        {t("endHour")} <span className="req">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={startDate.endHour}
                                        onChange={(date) => {
                                            setStartDate({ ...startDate, endHour: date });
                                            $("#classStartDateEndHour").removeClass("is-invalid");
                                            setFormChanged(true);
                                            //setUpdatedDate(true);
                                        }}
                                        showIcon
                                        locale="pl"
                                        dateFormat="HH:mm"
                                        icon={<FontAwesomeIcon icon={faClock} />}
                                        className="mb-3"
                                        placeholderText={t("choose")}
                                        timeCaption={t("hour")}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={5}
                                        disabled={!startDate.date || !startDate.startHour || blockForm}
                                        id="classStartDateEndHour"
                                    />
                                </Form.Group>
                            </Col>
                            {/* updatedDate && (
                                <Col xs={12}>
                                    <Alert className="alert-small mb-3" variant="info">
                                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                        {t("info.updateClassDataDateChanged")}
                                    </Alert>
                                </Col>
                            ) */}
                            <Col xs={12}>
                                <Form.Group controlId={"classSlots"} className="mb-3 mt-lg-0">
                                    <Form.Label>
                                        {t("templates.classSlots")} <span className="req">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        value={data.class_slots}
                                        onChange={(e) => {
                                            setData({ ...data, class_slots: e.target.value });
                                            $("#classSlots").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                        placeholder={t("typeNumber")}
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <ClassLevelsDropdown
                                    value={data.class_level_code}
                                    onChange={(v) => {
                                        setData({ ...data, class_level_code: v });
                                        setFormChanged(true);
                                        $("#classLvl").removeClass("is-invalid");
                                    }}
                                    id="classLvl"
                                    req
                                />
                            </Col>
                            <Col xs={12}>
                                <InstructorsDropdown
                                    value={data.instructor_user_id}
                                    onChange={(v) => {
                                        setData({ ...data, instructor_user_id: v });
                                        setFormChanged(true);
                                        $("#instructorDropdown").removeClass("is-invalid");
                                    }}
                                    id="instructorDropdown"
                                    req
                                    label
                                />
                            </Col>
                            <Col xs={12}>
                                <Form.Group className="mb-3" controlId={`classInstructorLabel`}>
                                    <Form.Label className="w-100">{t(`classes.classGuest`)}</Form.Label>
                                    <p className="text-small mb-2">{t("classes.classGuestEmptyHelper")}</p>
                                    <Form.Control
                                        value={data.instructor_label}
                                        onChange={(el) => {
                                            setData({ ...data, instructor_label: el.target.value });
                                            $("#classInstructorLabel").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                        placeholder={t(`classes.classGuestPlaceholder`)}
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Form.Group controlId="radioGroupbookingWindow" className="mb-3">
                                    <Form.Label>
                                        {t(`classes.bookingWindow`)} <span className="req">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={data.class_signup_start_time}
                                        onChange={(date) => {
                                            setData({ ...data, class_signup_start_time: date });
                                            $("#classSignUpStartDate").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                        showIcon
                                        locale="pl"
                                        dateFormat="yyyy-MM-dd"
                                        icon={<FontAwesomeIcon icon={faCalendar} />}
                                        className="mb-3"
                                        placeholderText={t("choose")}
                                        id="classSignUpStartDate"
                                        disabled={blockForm}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mb-3">
                                <Checkbox
                                    checked={multipleAction}
                                    label={t("schedule.makeChangeForAll")}
                                    onChange={() => {
                                        setMultipleAction(!multipleAction);
                                        setFormChanged(true);
                                    }}
                                />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={onClose}>
                            {t("cancel")}
                        </Button>
                        <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                            {t("saveChanges")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default UpdateClassData;
